import Reveal from "./Reveal";
import { FLEET_STATS } from "@/data/content";

const Fleet = () => (
  <section id="fleet" data-testid="fleet-section" className="py-20 md:py-28 bg-sky-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div>
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-wider text-primary">Our Fleet</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-foreground leading-tight">
            A Modern Fleet <span className="text-primary">Ready to Deliver</span>
          </h2>
          <p className="mt-4 text-muted-foreground text-base md:text-lg leading-relaxed">
            Our fleet of well-maintained, GPS-tracked vehicles is ready to handle deliveries of all
            sizes — from envelopes to pallets. Every vehicle is clean, branded, and driven by a
            professional.
          </p>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 gap-4 md:gap-6">
          {FLEET_STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.07}>
              <div className="rounded-2xl bg-white p-5 border border-border/60 shadow-sm">
                <div className="text-2xl md:text-3xl font-extrabold text-primary">{s.value}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.1}>
        <div className="rounded-3xl overflow-hidden shadow-2xl shadow-primary/10 border border-border/60">
          <img src="/assets/fleet.png" alt="On Time Couriers fleet" className="w-full h-auto object-cover" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default Fleet;
